export default "__VITE_ASSET__BkWzGcMm__"